import axios from "axios";
import {downloadFile} from "JQueryScripts/dataLayer/downloadFile";

const AFTER_DOWNLOAD_URL = '/after-download';
const SAVE_BUILD_INFO_URL = '/rest/download/save-build-information';
const BUILD_DOWNLOAD_URL = '/rest/download/build';

export const downloadHandlers = () => {
    $('#notes-button').click(function () {
        $('.modal#version .modal-header__title').text($(this).parent().find('.main-download__info-version').text());
        $('.modal#version .modal-body__version-content').html($(this).data('notes'));
    });

    $('.versions__notes > #notes-button').click(function () {
        $('.modal#version .modal-header__title').text($(this).parents('.versions__top').find('.versions__name').text());
        $('.modal#version .modal-body__version-content').html($(this).data('notes'));
    });

    $('.download-button').click(function () {
        if ($(this).data('redirect') !== undefined) {
            $('.modal#before-download').hide();
            window.location.href = $(this).data('redirect');

            return;
        }

        if ($(this).parent().is('.main-download__button')) {
            $('.modal#before-download .modal-header__title').text($(this).parents('.main-download').find('.main-download__info-version').text());

        } else {
            $('.modal#before-download .modal-header__title').text($(this).parents('.versions__top').find('.versions__name').text());
        }

        $('.modal#before-download .button-accept').data('platform', $(this).data('platform'));
        $('.modal#before-download .button-accept').data('buildId', $(this).data('buildId'))
    });
    $('#after-download').on('hidden.bs.modal', function (e) {
        $('body').css('overflow-y', 'auto');
    });

    $('.button-accept').click(function () {
        $('.modal#before-download .close').click();
        $('body').css('overflow-y', 'hidden');

        const buildId = $(this).data('buildId');
        const platform = $(this).data('platform');

        const params = new URLSearchParams();
        params.set('platform', platform);

        if (!buildId) {
            window.location = AFTER_DOWNLOAD_URL + '?' + params.toString();

            return;
        }

        params.set('buildId', buildId);

        axios.post(SAVE_BUILD_INFO_URL, { build_id: buildId, platform })
            .then(() => {
                window.location = AFTER_DOWNLOAD_URL + '?' + params.toString();
            });
    });

    $('.button-dont-accept').click(function () {
        $('.modal#before-download .close').click();
    });
};

export const startDownload = () => {
    if ($('.after-download').length === 0) {
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);

    axios.get(BUILD_DOWNLOAD_URL  + '?' + urlParams.toString())
        .then((response) => {
            if (response.data.data !== undefined) {
                downloadFile(
                    response.data.data.isPerson,
                    response.data.data.type,
                    response.data.data.planType,
                    response.data.data.url,
                    response.data.data.platform,
                );
            }

            const link = response.data.data !== undefined ? response.data.data.url : response.data.url;

            $(
                "<iframe>",
                {
                    "class": "invisible-download-frame",
                    "src": link,
                }
            )
                .appendTo('body');
        });
};
